import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TestsComponent} from './tests/tests.component';
import {TestDetailsComponent} from './test-details/test-details.component';
import {CreateTestComponent} from './create-test/create-test/create-test.component';

export const routes: Routes = [
  {path: '', redirectTo: 'create-test', pathMatch: 'full'},
  {path: 'test/:id', component: TestDetailsComponent, title: 'Test Details'},
  {path: 'create-test', component: CreateTestComponent, title: 'Create Test'},
  {
    path: 'tests',
    redirectTo: 'create-test',
    // component: TestsComponent,
    // title: 'Tests'
  },

// Wildcard route for 404s - redirect to create-test
  {path: '**', redirectTo: 'create-test'}
];
